// extracted by mini-css-extract-plugin
module.exports = {"svg-circle__spin":"shared-tapestry-splash-screen_svg-circle__spin__nIjjW","spin-around":"shared-tapestry-splash-screen_spin-around__SC_C1"};